const PROXY_MAP = {
    development: {
        '/saas': {
            target: 'http://www.smartprocure.cn',
            changeOrigin:true,
        },
        '/web': {
            target: 'http://web.smartprocure.cn',
            changeOrigin:true,
        },
    },
    production: {
        '/saas': {
            target: 'http://www.smartprocure.cn',
            changeOrigin:true,
        },
        '/web': {
            target: 'http://web.smartprocure.cn',
            changeOrigin:true,
        },
    }
};

const PROXY_ENV = PROXY_MAP[process.env.NODE_ENV];

export default {
    head: {
        title: '惠智采',
        meta: {
            description: '致力于高效采购、智慧管理，智能采购综合管理平台，轻松搞定采购',
            keywords: '采购,管理,内控,智能,协作,跨部门,高效,智慧,招标,投标,采购人,代理,投标人,供应商',
        },
        icon: '/favicon.ico'
    },
    plugins: {
        element: true,
        myComs: true,
        vuexStorage: false,
        jquery: true,
        sentry: false,
        cnzz: {
            id: '1281390936',
            show: 'pic1'
        }
    },
    proxy: PROXY_ENV,
}
